module.exports = __webpack_public_path__ + "img/instagramestory10.07c9f326.jpg";